{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/archives",
	"title": "Archives",
	"category": "widgets",
	"description": "Display a date archive of your posts.",
	"textdomain": "default",
	"attributes": {
		"displayAsDropdown": {
			"type": "boolean",
			"default": false
		},
		"showLabel": {
			"type": "boolean",
			"default": true
		},
		"showPostCounts": {
			"type": "boolean",
			"default": false
		},
		"type": {
			"type": "string",
			"default": "monthly"
		}
	},
	"supports": {
		"align": true,
		"__experimentalBorder": {
			"radius": true,
			"color": true,
			"width": true,
			"style": true
		},
		"html": false,
		"spacing": {
			"margin": true,
			"padding": true,
			"__experimentalDefaultControls": {
				"margin": false,
				"padding": false
			}
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"color": {
			"gradients": true,
			"link": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true,
				"link": true
			}
		},
		"interactivity": {
			"clientNavigation": true
		}
	},
	"editorStyle": "wp-block-archives-editor"
}
